type GlobalMiddlewareHeaders = {
  'X-Frame-Options': 'SAMEORIGIN';
  'Content-Security-Policy': string | null;
};

const GlobalMiddlewareHeaders: GlobalMiddlewareHeaders = {
  'X-Frame-Options': 'SAMEORIGIN',
  'Content-Security-Policy': null,
};

export default GlobalMiddlewareHeaders;
